const sanityClient = require('@sanity/client')

const client = sanityClient({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
})

const sanityQuery = (query) => {
  return new Promise((resolve, reject) => {
    client.fetch(query).then(result => {
      resolve(result)
    })
  })
}

export default sanityQuery



// WEBPACK FOOTER //
// ./src/sanityQuery.js